<section class="auth-card" aria-labelledby="auth-code-title">
  <form class="auth-form" [formGroup]="form" (ngSubmit)="submit()">
    <div class="auth-card__header">
      <pa-button
        icon="pi pi-arrow-left"
        variant="outlined"
        size="small"
        severity="secondary"
        aria-label="Назад"
        (click)="back()"
      />
      <div class="auth-card__intro">
        <h1 class="auth-card__title auth-card__title--left" id="auth-code-title">
          Введите код из письма
        </h1>
        <p *ngIf="isRegistration; else loginCodeSubtitle" class="auth-card__subtitle">
          Личный кабинет создан. Мы отправили код на
          <span class="auth-card__email">{{ login }}</span>.
          Проверьте папку «Спам», если письмо не пришло.
        </p>
        <ng-template #loginCodeSubtitle>
          <p class="auth-card__subtitle">
            Мы отправили код на
            <span class="auth-card__email">{{ login }}</span>.
            Проверьте папку «Спам», если письмо не пришло.
          </p>
        </ng-template>
      </div>
    </div>

    <div class="auth-code-field" (keydown.enter)="onCodeEnter($event)">
      <pa-input-otp
        formControlName="code"
        [length]="4"
        [invalid]="showCodeError"
        [errorText]="showCodeError ? codeErrorText : ''"
      />
    </div>

    <pa-button
      [label]="isRegistration ? 'Подтвердить' : 'Войти'"
      [fullWidth]="true"
      styleClass="auth-submit"
      [disabled]="isCodeSubmitDisabled()"
      (click)="submit()"
    />

    <pa-button
      label="Запросить код повторно"
      variant="outlined"
      severity="secondary"
      [fullWidth]="true"
      styleClass="auth-submit auth-submit--outlined"
      (click)="resendCode()"
    />

    <app-support-link-v2 />
    <p class="auth-version">ver. {{ environment.appVer }}</p>
  </form>
</section>
